import React from "react";
import { Breadcrumb, Col, Container, Row, Card, ListGroup } from "react-bootstrap";
import Link from "next/link";

import BreadcrumbItem from '../components/BreadcrumbItem';
import data from "../data/methodology.json";

export async function getStaticProps() {
  return {
    props: {
      nav: {
        light: true,
        classes: "shadow",
        color: "white",
      },
      canonical: `${process.env.BASE_URL}/methodology`,
      title: data.title,
      meta: data.meta,
    },
  }
}

const Methodology = () => {
  const sections = data.sections || [];

  const handleScroll = (e, id) => {
    e.preventDefault();
    const targetElement = document.getElementById(id);

    if (targetElement) {
      const offset = 120;
      const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <React.Fragment>
      <section className="hero py-5 py-lg-7">
        <Container className="position-relative">
          <Breadcrumb listProps={{ className: "ps-0 justify-content-center" }} >
            <BreadcrumbItem href="/">Home</BreadcrumbItem>
            <BreadcrumbItem active>{data.subtitle}</BreadcrumbItem>
          </Breadcrumb>
          <h1 className="hero-heading mb-4 text-center font-weight-bold">{data.title && data.title}</h1>
          {data.content && (
            <Row>
              <Col xl="8" className="mx-auto text-center">
                <p className="lead mb-0" style={{ lineHeight: '1.6' }}>
                  {data.content}
                </p>
              </Col>
            </Row>
          )}
        </Container>
      </section>
      <section className="py-6">
        <Container>
          <Row>
            {/* 1/4 Left: Table of Contents */}
            <Col lg="3" className="mb-5 mb-lg-0">
              <aside className="pe-xl-3 pe-lg-2 sticky-top" style={{ top: '100px', zIndex: '10' }}>
                <Card className="border-0 mb-5 rounded-0">
                  <Card.Header className="py-4 border-0 rounded-0" style={{ backgroundColor: '#F2FBF8' }}>
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h2 className="mb-0 h5">Table of contents</h2>
                      </div>
                    </div>
                  </Card.Header>
                  <ListGroup variant="flush" className="text-sm rounded-0">
                    {sections.map((section) => (
                      <Link 
                        key={section.id} 
                        href={`#${section.id}`} 
                        onClick={(e) => handleScroll(e, section.id)} 
                        className="list-group-item list-group-item-action py-3 text-reset"
                        style={{ borderBottom: '1px solid #eee' }}
                      >
                        {section.title}
                      </Link>
                    ))}
                  </ListGroup>
                </Card>
              </aside>
            </Col>

            {/* 3/4 Right: Main Content Area */}
            <Col lg="9">
              {sections.map((section, index) => (
                <div key={section.id} id={section.id} className="mb-4 scroll-mt">
                  <h2 className="h4 mb-4">{section.title}</h2>
                  <div 
                    className="text-gray-900 text-sm" 
                    style={{ lineHeight: '1.7' }}
                    dangerouslySetInnerHTML={{ __html: section.content }}
                  />
                  {index < sections.length - 1 && <hr className="my-5" />}
                </div>
              ))}
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default Methodology
